import { createApi } from "@reduxjs/toolkit/query/react";
import { reservationAxiosQuery } from "../../utils/axios/reservation.axios";
import {
  IAttachPaymentProps,
  IPaymentHistory,
  IPaymentResponse,
  IPaymentsProps,
} from "../../interfaces/payments/IPaymentsProps";
import { PaginatedApiResponse } from "../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../interfaces/shared/IPaginationPayload";

export const paymentsAPI = createApi({
  reducerPath: "payments",
  baseQuery: reservationAxiosQuery(),
  tagTypes: ["payments"],
  endpoints: (builder) => ({
    customerCallTopUps: builder.mutation<
      { data: IPaymentResponse },
      IPaymentsProps
    >({
      query: (data) => ({
        url: `/customer-call-top-ups`,
        method: "POST",
        data,
      }),
    }),
    attachPayment: builder.mutation<
      { data: { customerId: string; paymentMethodId: string } },
      IAttachPaymentProps
    >({
      query: (data) => ({
        url: "/customer-call-top-ups/attach-payment-method",
        method: "PUT",
        data,
      }),
    }),
    getTransactionHistory: builder.query<
      PaginatedApiResponse<IPaymentHistory>,
      IPaginationPayload
    >({
      query: ({ pageNumber, pageSize, previousPage, nextPage }) => ({
        url: previousPage
          ? `/customer-call-top-ups/payment-intents?page=${pageNumber}&size=${pageSize}&previousPage=${previousPage}`
          : nextPage
            ? `/customer-call-top-ups/payment-intents?page=${pageNumber}&size=${pageSize}&nextPage=${nextPage}`
            : `/customer-call-top-ups/payment-intents?page=${pageNumber}&size=${pageSize}`,
        method: "PUT",
        data: {},
      }),
    }),
    getPaymentMethods: builder.query<
      {
        data: {
          data: {
            id: string;
            customer: string;
            card: {
              last4: string;
              display_brand: string;
            };
          }[];
        };
      },
      void
    >({
      query: () => ({
        url: "/customer-call-top-ups/payment-methods",
        method: "GET",
      }),
    }),
    //
  }),
});

export const {
  useCustomerCallTopUpsMutation,
  useAttachPaymentMutation,
  useGetPaymentMethodsQuery,
  useGetTransactionHistoryQuery,
} = paymentsAPI;
